module.exports = __webpack_public_path__ + "static/media/caret_down.bca475f6.svg";